import { ServiceRequest } from "../utils/service-request"
import {
    MOTOR_CADASTRO_PATH,
    MOTOR_CADASTRO_TEMPORARIO_PATH
} from "../utils/api-routes"

class MotorDataAniversarioService {
    constructor() {
        this.request = new ServiceRequest()
    }

    // Temporario
    async getTemporarioDataAniversario(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/data-aniversario`
        return this.request.get(path)
    }

    async createCadastroTemporarioDataAniversario(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/data-aniversario`
        return this.request.post(path, payload)
    }

    async deleteCadastroTemporarioDataAniversario(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/data-aniversario`
        return this.request.delete(path)
    }

    // Producao
    async getDataAniversario(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/data-aniversario`
        return this.request.get(path)
    }

    async createCadastroDataAniversario(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/data-aniversario`
        return this.request.post(path, payload)
    }

    async updateCadastroDataAniversario(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/data-aniversario`
        return this.request.put(path, payload)
    }

    async deleteCadastroDataAniversario(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/data-aniversario`
        return this.request.delete(path)
    }
}

export default MotorDataAniversarioService